<template>
  <div>
    <div class="box content" v-if="!navigation">
      <div class="box_l" v-if="this.path!='/profile'">
        <div class="box_l_t">快捷入口</div>
        <div class="box_l_i">
                <span v-for="(item,index) in KuaiJiData" :key="index" @click="KuaiJieTo(item)">
                    <img :src="item.image" alt>
                </span>
        </div>
        <div class="box_l_b">相关连接</div>
        <div class="box_l_a">
          <ul class="box_l_a_ul">
            <li class="box_l_a_li" v-for="(item,index) in XiangGuanData" :key="index" @click="routeTo(item)">
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="profile" v-if="this.path=='/profile'">
        <div class="profile_titleL">
          <p class="profile_title_name">{{ profileTitle }}</p>
          <p class="profile_title_en">ABOUT CUEB</p>
        </div>
        <div class="profile_titleR">
          <ul class="profile_titleR_ul">
            <li class="profile_titleR_li" @click="$router.push('/')">
              <span>首页</span>
            </li>
            <li class="profile_titleR_li" v-for="(item,index) in data" :key="index"
                @click="navigateTo(item)">
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div >
    <div class="navigation" v-if="navigation">

      <div :class="tabBarData == item.id? 'navigation_title selected':'navigation_title'" v-for="(item,index) in navChildData" :key="index" @click="routerpush(item)">{{item.name}}</div>
      <div class="navigation_title ">系部介绍</div>
<!--      <div class="navigation_title selected">教学工作</div>-->
<!--      <div class="navigation_title ">党团工作</div>-->
<!--      <el-collapse v-model="activeName" accordion v-for="(item,index) in navChildData" :key="index">-->
<!--        <el-collapse-item :title="item.name" :name="index">-->
<!--          <div v-for="(el,elindex) in navChildData" :key="elindex">{{el.name}}</div>-->
<!--&lt;!&ndash;          <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>&ndash;&gt;-->
<!--        </el-collapse-item>-->
<!--      </el-collapse>-->
    </div>
  </div>
</template>

<script>
import NavTop from '../comcomponents/NavTop.vue'
import child from '../../api/child.js'
import home from '../../api/home'
// import home from '../../api/home.js'

export default {
  name: 'PartyPage',
  components: {NavTop},
  props: ['parentData', 'navigation', 'tabBarData'],
  data () {
    return {
      profileTitle: '',
      // 路径
      path: '',
      // 数据
      data: [],
      // 快捷入口数据
      KuaiJiData: [],
      // 相关连接数据
      XiangGuanData: [],
      //   导航数据
      navChildData: [],
      activeName: 1
    }
  },
  created () {
    console.log(this.path)
    this.path = this.removeAfterFirstNumber(this.$route.path)
    console.log(this.path, 'path')
    if (this.navigation) {
      this.getNav()
    }
    const paths = ['/common/more', '/common/detail', '/basic/detail', '/common/section/detail']
    if (paths.some(path => this.path === path)) {
      this.getLink('/common/section/more')
      return
    }
    // console.log(11111)
    // console.log(this.parentData)
    // 调用

    this.getLink(this.path)

  },
  methods: {
    async getNav () {
      try {
        // console.log(this.parentData,111)
        // if (this.parentData) {
          const res = await home.getNav({id: this.parentData})
          this.navChildData = []
          // console.log('parentData',this.parentData)
          if (res.code == 200) {
            this.$nextTick(() => {
              // 这里可以安全地操作DOM
              // this.navData = res.data
              // console.log(this.navData)
              // this.navChildData = res.data.children
              res.data.children.forEach(el => {
                // console.log(el)
                if (el.placeType == 3) {
                  // this.navChildData.push(el)
                } else {
                  this.navChildData.push(...el.children)
                }
              })
              // console.log(1111)
              // console.log(this.navChildData)
            })
          }
        // } else {
        //   const res = await home.getNav({id: 1})
        //   if (res.code == 200) {
        //     this.navData = res.data
        //     this.navChildData = res.data.children
        //   }
        // }
      } catch (e) {
        console.error(e)
      }
    },
    // 获取数据
    async getLink (path) {
      try {
        const res = await child.getRealLink({path: path})
        if (res.data) {
          if (res.data[0].parentId) {
            if (this.extractNumberFromPath(this.$route.path) == 45) {
              this.data = res.data.filter(item => item.parentId == 45)
              this.profileTitle = '部门职责'
              return
            }
            if (this.extractNumberFromPath(this.$route.path) == 156 || this.extractNumberFromPath(this.$route.path) == 157 || this.extractNumberFromPath(this.$route.path) == 548 || this.extractNumberFromPath(this.$route.path) == 549) {
              this.data = res.data.filter(item => item.parentId == 156)
              this.profileTitle = '部门职责'
              return
            }
            // 学校概况数据
            this.data = res.data.filter(item => item.parentId == 10)
            this.profileTitle = '学校概况'
            return
          }
          // 快捷入口数据
          this.KuaiJiData = res.data.filter(item => item.type == 2)
          console.log(this.KuaiJiData, 'kuaijie')
          // 相关连接数据
          this.XiangGuanData = res.data.filter(item => item.type == 1)
        }
      } catch (e) {
        console.log(e)
      }
    },

    // 相关连接跳转
    routeTo (item) {
      this.$router.push(item.path + '/' + item.tabBarId)
    },
    // 快捷入口跳转
    KuaiJieTo (item) {
      if (item.path.startsWith('https')) {
        window.open(item.path, '_blank')
        return
      }
      if (item.tabBarId) {
        this.$router.push(item.path + '/' + item.tabBarId)
        return
      }
    },
    // 正常跳转
    navigateTo (item) {
      if (item.path.startsWith('https')) {
        window.open(item.path, '_blank')
        return
      }
      if (item.appointTabId) {
        let encodedId = encodeURIComponent(item.appointTabId)
        let decodedId = decodeURIComponent(encodedId)
        this.$router.push(item.path + decodedId)
        return
      }
      if (item.tabBarId) {
        this.$router.push(item.path + '/' + item.tabBarId)
        return
      }
      this.$router.push(item.path)
    },
    openExternalLink (event) {
      // 阻止默认事件，防止a标签打开新页面
      event.preventDefault()
      // 使用window.location.href进行跳转
      window.location.href = 'https://hbdfxyjob.jysd.com/'
    },
    // 取数字
    extractNumberFromPath (path) {
      // 使用正则表达式匹配路径中的数字
      const match = path.match(/\d+/)
      // 如果匹配成功，返回第一个匹配的数字，否则返回null
      return match ? parseInt(match[0], 10) : null
    },
    // 过滤路径
    removeAfterFirstNumber (url) {
      // 查找第一个数字的位置
      const firstNumberIndex = url.search(/\d/)

      // 如果找到了数字，截取数字之前的内容，否则返回原始字符串
      return firstNumberIndex !== -1 ? url.substring(0, firstNumberIndex - 1) : url
    },
    // 跳转处理
    routerpush (item) {
      if (item.path == this.$route.path) {
        window.location.reload()
        return
      }
      if (item.pathType == 0) {
        return
      }
      if (item.pathType == 2) {
        window.open(item.path, '_blank')
        return
      }
      if (item.appointTabId) {
        // const [firstNumber, secondNumber] = this.extractFirstAndSecondNumbers(item.appointTabId)
        // this.$router.push(item.path + '/' + firstNumber + '/' + secondNumber)
        let encodedId = encodeURIComponent(item.appointTabId)
        let decodedId = decodeURIComponent(encodedId)
        this.$router.push(item.path + decodedId)
        window.location.reload()
        return
      }
      if (item.path == '/common/section/more') {
        this.$router.push(item.path + '/' + item.parentId + '/' + item.id)
        return
      }
      if (item.tabBarId) {
        this.$router.push({path: item.path + '/' + item.tabBarid})
        return
      }
      if (!item.tabBarId) {
        if (item.path == '/home' || item.path == '/organization') {
          this.$router.push({path: item.path})
          return
        }
        this.$router.push({path: item.path + '/' + item.id})
        return
      }
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  //margin: 50px auto !important;
  display: flex;
  justify-content: space-between;
  width: 195px !important;
}

// 相关链接
.box_l {
  width: 193px;
  margin-top: 50px;

  .box_l_t {
    width: 193px;
    height: 38px;
    background: #9e070e;
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .box_l_i {
    width: 193px;
    height: 212px;
    border-top: none;
    border-bottom: none;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    background: #f8f8f8;
    margin-bottom: 20px;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      cursor: pointer;

      img {
        width: 50px;
      }
    }
  }

  .box_l_b {
    width: 193px;
    height: 38px;
    background: #9e070e;
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .box_l_a {
    width: 193px;
    background: #f8f8f8;
    border-top: none;

    .box_l_a_ul {
      padding: 10px;
      display: inline-table;

      .box_l_a_li {
        margin-right: 10px;
        display: inline-block;
        margin-bottom: 10px;

        span {
          display: inline-block;
          font-size: 14px;
          color: #c1c1c1;
          border: 1px solid #c1c1c1;
          padding: 5px 10px;
          border-radius: 25px;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }
  }
}

// 学校概括
.profile {
  width: 195px;
  height: 525px;
  background: url(../../assets/images/list.png);
  background-size: 100% 100%;
  position: relative;
  margin-top: -80px;
  z-index: 99;

  .profile_titleL {
    padding-top: 50px;

    .profile_title_name {
      font-size: 30px;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }

    .profile_title_en {
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 36px;
    }
  }

  .profile_titleR {
    width: 195px;
    margin-top: 90px;

    .profile_titleR_ul {
      width: 100%;

      .profile_titleR_li {
        width: 100%;
        height: 30px;
        text-align: center;
        line-height: 30px;

        &:hover {
          background: #eeeeee;
        }

        span {
          display: block;
          color: #666;
          font-size: 15px;
          cursor: pointer;
        }
      }
    }
  }
}

ul, ol, li {
  list-style: none;
}

.content {
  width: 1200px;
  margin: 0 auto;
}


//竖列导航栏
.navigation{
  width: 195px !important;
  min-height: 525px;
}
.navigation_title{
  padding: 10px 30px;
  //border: 1px solid #f00;
  border-radius: 5px;
  margin: 10px 0 0;
  font-size: 15px;
}
.navigation_title:hover{
  cursor:pointer;
  background-color: #e60012;
  color: #fff;
}
.selected{
  background-color: #e60012;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/DetilsPage/index.vue